import { createAction, props } from '@ngrx/store';

import { ConnectorListEntity } from '../components/connector-list/connector-list.entity';

export enum ConnectorActions {
	InitConnectorList = '[Connector] get connector list',
	RefreshConnectorList = '[BE][Connector] refresh Connector list',
	FetchConnectorListFail = '[BE][Connector] fetch Connector list fail',
	FetchConnectorListSuccess = '[BE][Connector] fetch Connector list success',
	NavigateToConnectorRoute = '[Connector] navigate to Connector route',
	NavigateToConnectorCreateRoute = '[Connector] navigate to Connector create route',
	NavigateToConnectorDuplicateRoute = '[Connector] navigate to Connector duplicate route',
	NavigateToDepotFromConnectorRoute = '[Connector] navigate to depot with connector route',
	UpdateIncludePublic = '[Connector] update include public',
	OpenDeleteConfirmationPopup = '[Connector] open delete confirm popup',
	DeleteConnector = '[Connector] delete connector',
	BulkDeleteConnectors = '[Connector] delete many connectors',
	DeleteConnectorFail = '[BE][Connector] delete connector fail',
	ToggleConnectorStatus = '[BE][Connector] toggle connector status',
	FetchPublicProjectDetails = '[BE][Connector] get public project details',
	FetchPublicProjectDetailsSuccess = '[BE][Connector] get public project details success',
	FetchPublicProjectDetailsFailure = '[BE][Connector] get public project details failure',
}

export const initConnectorList = createAction(
	ConnectorActions.InitConnectorList
);

export const refreshConnectorList = createAction(
	ConnectorActions.RefreshConnectorList
);

export const fetchConnectorListSuccess = createAction(
	ConnectorActions.FetchConnectorListSuccess,
	props<{ connectorList: ConnectorListEntity }>()
);

export const fetchConnectorListFail = createAction(
	ConnectorActions.FetchConnectorListFail,
	props<{ error: unknown }>()
);
export const navigateToConnector = createAction(
	ConnectorActions.NavigateToConnectorRoute,
	props<{
		id: number;
		connectorType: string;
	}>()
);
export const navigateToConnectorCreate = createAction(
	ConnectorActions.NavigateToConnectorCreateRoute
);
export const navigateToConnectorDuplicate = createAction(
	ConnectorActions.NavigateToConnectorDuplicateRoute,
	props<{ id: number; connectorType: string }>()
);

export const navigateToDepotFromConnector = createAction(
	ConnectorActions.NavigateToDepotFromConnectorRoute,
	props<{ id: number }>()
);

export const updateIncludePublic = createAction(
	ConnectorActions.UpdateIncludePublic,
	props<{ includePublic: boolean }>()
);

export const openDeleteConfirmationPopup = createAction(
	ConnectorActions.OpenDeleteConfirmationPopup,
	props<{ connectorId: Array<number>; connectorLabel: string }>()
);
export const deleteConnector = createAction(
	ConnectorActions.DeleteConnector,
	props<{ connectorId: number }>()
);

export const bulkDeleteConnectors = createAction(
	ConnectorActions.BulkDeleteConnectors,
	props<{ connectorIds: Array<number> }>()
);

export const deleteConnectorFail = createAction(
	ConnectorActions.DeleteConnectorFail
);

export const toggleConnectorStatus = createAction(
	ConnectorActions.ToggleConnectorStatus,
	props<{ connectorId: number; connectorType: string }>()
);

export const fetchPublicProjectDetails = createAction(
	ConnectorActions.FetchPublicProjectDetails,
	props<{ connectorId: number }>()
);

export const fetchPublicProjectDetailsSuccess = createAction(
	ConnectorActions.FetchPublicProjectDetailsSuccess,
	props<{ connectorId: number }>()
);

export const fetchPublicProjectDetailsFail = createAction(
	ConnectorActions.FetchPublicProjectDetailsFailure,
	props<{ error: unknown }>()
);
